export const UPDATE_SELECTED_ALTERNATIVES = "UPDATE_SELECTED_ALTERNATIVES"
